<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <div>
        <div class="row">
          <div class="h3">累計轄區車流統計</div>
        </div>

        <div class="container-fluid ">
          <div class="row">
            <div class="col-6 col-xl-2" v-for="(point, i) in VDData" :key="i">
              <h5 class="font-weight-semibold text-dark text-uppercase mb-0 mt-3">{{ point.name }}</h5>
              <p><small>{{ point.subName }}</small></p>
              <section class="card mb-2" v-for="(car, i2) in point.cars" :key="i2">
                <div :class="point.css">
                  <div class="widget-summary">
                    <div class="widget-summary-col widget-summary-col-icon">
                      <div class="summary-icon"> <i :class="car.icon"></i> </div>
                    </div>
                    <div class="widget-summary-col">
                      <div class="summary">
                        <h4 class="title">{{ car.name }}</h4>
                        <div class="info"> <strong class="amount">{{ car.count }}</strong> </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import utils from "../../utils/utils";
import CONST from "../../utils/const";

export default {
  name: "Home",
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      VDInterval: null,
      VDData: [
        {
          id: CONST.VD_ID.NORTH,
          roadEntranceId: CONST.VD_ENTRANCE_ID.NORTH,
          name: "北口進入",
          subName: '(花蓮大橋、台11線4K)',
          color: "bg-primary h5 text-white p-2",
          css: 'card-body bg-primary',
          cars: [
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.T}${CONST.VD_DETECTION_ID.IN}`,
              enumType: CONST.CAR_TYPE.TRUCK,
              name: "聯結車",
              icon: "fas fa-truck-moving",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.L}${CONST.VD_DETECTION_ID.IN}`,
              enumType: CONST.CAR_TYPE.BUS,
              name: "大型車",
              icon: "fas fa-bus",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.S}${CONST.VD_DETECTION_ID.IN}`,
              enumType: CONST.CAR_TYPE.CAR,
              name: "小型車",
              icon: "fas fa-car",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.M}${CONST.VD_DETECTION_ID.IN}`,
              enumType: CONST.CAR_TYPE.MOTO,
              name: "機車",
              icon: "fas fa-motorcycle",
              count: "0",
            },
            {
              name: '預估人流',
              icon: 'fas fa-user',
              count: "0",
            }
          ],
        },
        {
          id: CONST.VD_ID.NORTH,
          roadEntranceId: CONST.VD_ENTRANCE_ID.NORTH,
          name: "北口離開",
          subName: '(花蓮大橋、台11線4K)',
          color: "bg-primary h5 text-white p-2",
          css: 'card-body bg-tertiary',
          cars: [
            {
              type:  `${CONST.VD_VEHICLE_TYPE_ID.T}${CONST.VD_DETECTION_ID.OUT}`,
              enumType: CONST.CAR_TYPE.TRUCK,
              name: "聯結車",
              icon: "fas fa-truck-moving",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.L}${CONST.VD_DETECTION_ID.OUT}`,
              enumType: CONST.CAR_TYPE.BUS,
              name: "大型車",
              icon: "fas fa-bus",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.S}${CONST.VD_DETECTION_ID.OUT}`,
              enumType: CONST.CAR_TYPE.CAR,
              name: "小型車",
              icon: "fas fa-car",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.M}${CONST.VD_DETECTION_ID.OUT}`,
              enumType: CONST.CAR_TYPE.MOTO,
              name: "機車",
              icon: "fas fa-motorcycle",
              count: "0",
            },
            {
              name: '預估人流',
              icon: 'fas fa-user',
              count: "0",
            }
          ],
        },
        {
          id: CONST.VD_ID.MIDDLE,
          roadEntranceId: CONST.VD_ENTRANCE_ID.MIDDLE,
          name: "中口進入",
          subName: '(玉長公路、台11線90K)',
          color: "bg-success h5 text-white p-2",
          css: 'card-body bg-primary',
          cars: [
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.T}${CONST.VD_DETECTION_ID.IN}`,
              enumType: CONST.CAR_TYPE.TRUCK,
              name: "聯結車",
              icon: "fas fa-truck-moving",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.L}${CONST.VD_DETECTION_ID.IN}`,
              enumType: CONST.CAR_TYPE.BUS,
              name: "大型車",
              icon: "fas fa-bus",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.S}${CONST.VD_DETECTION_ID.IN}`,
              enumType: CONST.CAR_TYPE.CAR,
              name: "小型車",
              icon: "fas fa-car",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.M}${CONST.VD_DETECTION_ID.IN}`,
              enumType: CONST.CAR_TYPE.MOTO,
              name: "機車",
              icon: "fas fa-motorcycle",
              count: "0",
            },
            {
              name: '預估人流',
              icon: 'fas fa-user',
              count: "0",
            }
          ],
        },
        {
          id: CONST.VD_ID.MIDDLE,
          roadEntranceId: CONST.VD_ENTRANCE_ID.MIDDLE,
          name: "中口離開",
          subName: '(玉長公路、台11線90K)',
          color: "bg-success h5 text-white p-2",
          css: 'card-body bg-tertiary',
          cars: [
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.T}${CONST.VD_DETECTION_ID.OUT}`,
              enumType: CONST.CAR_TYPE.TRUCK,
              name: "聯結車",
              icon: "fas fa-truck-moving",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.L}${CONST.VD_DETECTION_ID.OUT}`,
              enumType: CONST.CAR_TYPE.BUS,
              name: "大型車",
              icon: "fas fa-bus",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.S}${CONST.VD_DETECTION_ID.OUT}`,
              enumType: CONST.CAR_TYPE.CAR,
              name: "小型車",
              icon: "fas fa-car",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.M}${CONST.VD_DETECTION_ID.OUT}`,
              enumType: CONST.CAR_TYPE.MOTO,
              name: "機車",
              icon: "fas fa-motorcycle",
              count: "0",
            },
            {
              name: '預估人流',
              icon: 'fas fa-user',
              count: "0",
            }
          ],
        },
        {
          id: CONST.VD_ID.SOUTH,
          roadEntranceId: CONST.VD_ENTRANCE_ID.SOUTH,
          name: "南口進入",
          subName: '(中華大橋、台11線157K)',
          color: "bg-info h5 text-white p-2",
          css: 'card-body bg-primary',
          cars: [
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.T}${CONST.VD_DETECTION_ID.IN}`,
              enumType: CONST.CAR_TYPE.TRUCK,
              name: "聯結車",
              icon: "fas fa-truck-moving",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.L}${CONST.VD_DETECTION_ID.IN}`,
              enumType: CONST.CAR_TYPE.BUS,
              name: "大型車",
              icon: "fas fa-bus",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.S}${CONST.VD_DETECTION_ID.IN}`,
              enumType: CONST.CAR_TYPE.CAR,
              name: "小型車",
              icon: "fas fa-car",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.M}${CONST.VD_DETECTION_ID.IN}`,
              enumType: CONST.CAR_TYPE.MOTO,
              name: "機車",
              icon: "fas fa-motorcycle",
              count: "0",
            },
            {
              name: '預估人流',
              icon: 'fas fa-user',
              count: "0",
            }
          ],
        },
        {
          id: CONST.VD_ID.SOUTH,
          roadEntranceId: CONST.VD_ENTRANCE_ID.SOUTH,
          name: "南口離開",
          subName: '(中華大橋、台11線157K)',
          color: "bg-info h5 text-white p-2",
          css: 'card-body bg-tertiary',
          cars: [
          
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.T}${CONST.VD_DETECTION_ID.OUT}`,
              enumType: CONST.CAR_TYPE.TRUCK,
              name: "聯結車",
              icon: "fas fa-truck-moving",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.L}${CONST.VD_DETECTION_ID.OUT}`,
              enumType: CONST.CAR_TYPE.BUS,
              name: "大型車",
              icon: "fas fa-bus",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.S}${CONST.VD_DETECTION_ID.OUT}`,
              enumType: CONST.CAR_TYPE.CAR,
              name: "小型車",
              icon: "fas fa-car",
              count: "0",
            },
            {
              type: `${CONST.VD_VEHICLE_TYPE_ID.M}${CONST.VD_DETECTION_ID.OUT}`,
              enumType: CONST.CAR_TYPE.MOTO,
              name: "機車",
              icon: "fas fa-motorcycle",
              count: "0",
            },
            {
              name: '預估人流',
              icon: 'fas fa-user',
              count: "0",
            }
          ],
        },
      ],
    };
  },
  methods: {
    async getVDData() {
      const condition = {
        startTime: moment().startOf('day').toISOString(),
        endTime: moment().toISOString()
      }

      await this.$store.dispatch('trafficFlow/GetDailyTrafficFlowData', condition)
      const trafficFlowList = this.$store.getters['trafficFlow/getTrafficFlow']

      this.handleVDdata(trafficFlowList);
    },
    handleVDdata(data) {
      for (let i = 0; i < this.VDData.length; i++) {
        const VDRoadEntanceID = this.VDData[i].roadEntranceId;
        const trafficFlows = data.filter(d => d.roadEntranceId === VDRoadEntanceID)
        if (utils.isEmptyObject(trafficFlows)) {
          continue;
        }

        let cars = this.VDData[i].cars;
        for (let j = 0; j < cars.length; j++) {
          this.setVehicleCount(cars[j], trafficFlows);
        }
        this.setPeopleCount(cars)
      }
    },
    setVehicleCount(car, trafficFlows) {
      for(let i = 0 ; i < trafficFlows.length ; i++) {
        if(car.type === `${trafficFlows[i].vehicleType}${trafficFlows[i].driveDirection}`) {
          car.count = trafficFlows[i].totalCount
        }
      }
    },
    setPeopleCount(cars) {
      let estimatePeopleCount = 0
      const holidayMap = this.$store.getters['holidaySetting/getHolidayMap']
      const today = moment().startOf('day').format().split('+')[0]
      const isHoliday = holidayMap.get(today)? true : false

      const carTypeEnum = this.$store.getters['passengerEstimateSetting/getInternalEstimateWeight']
      for(let i = 0 ; i < cars.length-1 ; i++) { // 最後一項是預估人流
        const carEnum = carTypeEnum.find( e => e.enumType === cars[i].enumType)
        estimatePeopleCount = estimatePeopleCount + cars[i].count * (isHoliday? carEnum.holidayWeight : carEnum.weight)
      }

      cars[cars.length-1].count = Math.round(estimatePeopleCount)
    },
  },
  async mounted() {
    await this.getVDData();
    this.VDInterval = setInterval(async () => {
      await this.getVDData();
    }, CONST.REFRESH_DAT_TIMER_MIN);
  },
  destroyed() {
    if (this.VDInterval) clearInterval(this.VDInterval);
    this.VDInterval = null;
  },
};
</script>
